export const soHelperObj = {
  'malk': 'Alkalinity, ppm CaCO3',
  'ph': 'pH',
  'toc': 'Total Organic Carbon',
  'temp': 'Temperature',
  'tds': 'TDS, mg/l',
  'flow': 'Flow',
  'press': 'Pressure',
  'hardness': 'Hardness, ppm as CaCO3',
  'density': 'Density, kg/m3',
  'ionic_str': 'Ionic Strength',

  'Ca++': 'Calcium (Ca)',
  'Mg++': 'Magnesium (Mg)',
  'Na+': 'Sodium (Na)',
  'K+': 'Potassium (K)',
  'NH4+': 'Ammonia - N (NH4)',
  'Ba++': 'Barium (Ba)',
  'Sr++': 'Strontium (Sr)',
  'Fe++': 'Iron (Fe)',
  'Mn++': 'Manganese (Mn)',
  'SO4--': 'Sulfate (SO4)',
  'Cl-': 'Chloride (Cl)',
  'F-': 'Fluoride (F)',
  'NO3-': 'Nitrate (NO3)',
  'Br-': 'Bromide (Br)',
  'PO4---': 'Phosphate (PO4)',
  'B-': 'Boron (B)',
  'SiO2': 'Silica (SiO2)',
  'H2S': 'Hydrogen Sulfide (H2S)',
  'HCO3-': 'Bicarbonate (HCO3)',
  'CO2': 'Carbon Dioxide (CO2)',
  'CO3--': 'Carbonate (CO3)',

  'baso4': 'BaSO4 Saturation',
  'caf2': 'CaF2 Saturation',
  'srso4': 'SrSO4 Saturation',
  'lsi': 'Langelier Index',
  'sdi': 'Stiff-Davis Index',
  'caso4': 'CaSO4 Saturation',
  'struvite': 'Struvite Saturation',
  'sio2': 'SiO2 Saturation',
  'mgoh2': 'Magnesium Hydroxide Saturation',
  'osmotic_pressure': 'Osmotic Pressure',
  'conductivity': 'Conductivity at 25°C, µS/cm ',

  'streamName' : 'Stream Name',
  'source': 'Source',
  'destination': 'Destination'
};

export const soIonsObj = [
  { id: 'Ca++', propName : 'Calcium (Ca)'},
  { id: 'Mg++', propName : 'Magnesium (Mg)'},
  { id: 'Na+', propName : 'Sodium (Na)'},
  { id: 'K+', propName : 'Potassium (K)'},
  { id: 'NH4+', propName : 'Ammonia - N (NH4)'},
  { id: 'Ba++', propName : 'Barium (Ba)'},
  { id: 'Sr++', propName : 'Strontium (Sr)'},
  { id: 'Fe++', propName : 'Iron (Fe)'},
  { id: 'Mn++', propName : 'Manganese (Mn)'},
  { id: 'SO4--', propName : 'Sulfate (SO4)'},
  { id: 'Cl-', propName : 'Chloride (Cl)'},
  { id: 'F-', propName : 'Fluoride (F)'},
  { id: 'NO3-', propName : 'Nitrate (NO3)'},
  { id: 'Br-', propName : 'Bromide (Br)'},
  { id: 'PO4---', propName : 'Phosphate (PO4)'},
  { id: 'B-', propName : 'Boron (B)'},
  { id: 'SiO2', propName : 'Silica (SiO2)'},
  { id: 'H2S', propName : 'Hydrogen Sulfide (H2S)'},
  { id: 'HCO3-', propName : 'Bicarbonate (HCO3)'},
  { id: 'CO2', propName : 'Carbon Dioxide (CO2)'},
  { id: 'CO3--', propName : 'Carbonate (CO3)'}
];

export const soStreamPropObj = [
  { id: 'flow', propName: 'Flow'},
  { id: 'temp', propName: 'Temperature'},
  { id: 'press', propName: 'Pressure'},
  { id: 'tds', propName: 'TDS, mg/l'},
  { id: 'ph', propName: 'pH'},
  { id: 'malk', propName: 'Alkalinity, ppm CaCO3'},
  { id: 'hardness', propName: 'Hardness, ppm as CaCO3'},
  { id: 'density', propName: 'Density, kg/m3'},
  { id: 'ionic_str', propName: 'Ionic Strength'},
  { id: 'toc', propName: 'Total Organic Carbon'}
];

export const soSaturationDataObj = [
  { id: 'baso4', propName: 'BaSO4 Saturation'},
  { id: 'caf2', propName: 'CaF2 Saturation'},
  { id: 'caso4', propName: 'CaSO4 Saturation'},
  { id: 'sio2', propName: 'SiO2 Saturation'},
  { id: 'srso4', propName: 'SrSO4 Saturation'},
  { id: 'struvite', propName: 'Struvite Saturation'},
  { id: 'lsi', propName: 'Langelier Index'},
  { id: 'sdi', propName: 'Stiff-Davis Index'},
  { id: 'mgoh2', propName: 'Magnesium Hydroxide Saturation'},
  { id: 'osmotic_pressure', propName: 'Osmotic Pressure'},
  { id: 'conductivity', propName: 'Conductivity at 25°C, µS/cm '}
];

export const srcDest = [
  { id : 'streamName', propName: 'Stream Name'},
  { id : 'source', propName: 'Stream Source'},
  { id : 'destination', propName: 'Stream Destination'}
];

// Ions // Which checkBox will be already checked in 1st run : add in below array
let updatedIonsAr = [];

export const setUpdatedIonsAr = (upion) => {
  updatedIonsAr = upion;
};

export const getUpdatedIonsAr = () => {
  return updatedIonsAr;
};

// Stream Properties
let updatedStreamPropAr = ['flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density'];

export const setUpdatedStreamPropAr = (upstp) => {
  updatedStreamPropAr = upstp;
};

export const getUpdatedStreamPropAr = () => {
  return updatedStreamPropAr;
};

//  SaturationData
let updatedSaturationDataAr = ['osmotic_pressure', 'conductivity'];

export const setUpdatedSaturationDataAr = (upstdata) => {
  updatedSaturationDataAr = upstdata;
};

export const getUpdatedSaturationDataAr = () => {
  return updatedSaturationDataAr;
};

// SrcDect
let updatedSrcDectAr = ['streamName']; // 'source', 'destination'];

export const setUpdatedSrcDectAr = (upsrdt) => {
  updatedSrcDectAr = upsrdt;
};

export const getUpdatedSrcDectAr = () => {
  return updatedSrcDectAr;
};